module.exports = __webpack_public_path__ + "img/El-Centurion.6d22e0d2.jpg";